/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Geschlecht)
 */
export const Gender = {
  Female: 'Female',
  Male: 'Male',
  Divers: 'Divers',
} as const;
export type Gender = (typeof Gender)[keyof typeof Gender];
